export default __webpack_public_path__ + "static/media/img.22b236e9.jpg";